export const TRANSLATIONS_EN_HOME_QUALITY_AND_ALERTS = {
  "home.alerts.title": "Needs your attention",
  "home.alerts.viewAll": "View all",
  "home.alerts.empty": "No active alerts.",
  "home.alerts.loading": "Loading...",
  "home.alerts.errorMessage": "Could not load alerts.",
  "home.alerts.retry": "Retry",
  "home.qaHarness.title": "Home IA QA",
  "home.qaHarness.subtitle": "Local harness to validate real Home IA states",
  "home.qaHarness.copy": "This internal route renders the real /home components with typed fixtures so visual evidence can be captured without depending on the backend or an authenticated browser session.",
  "home.qaHarness.section.connectionEyebrow": "Connectivity",
  "home.qaHarness.section.connectionTitle": "SSE and pulse strip states",
  "home.qaHarness.section.heroEyebrow": "Protagonist",
  "home.qaHarness.section.heroTitle": "Next best decision states",
  "home.qaHarness.section.listEyebrow": "List",
  "home.qaHarness.section.listTitle": "Summary and compact list",
  "home.qaHarness.section.detailEyebrow": "Detail",
  "home.qaHarness.section.detailTitle": "Decision drawer states",
  "home.qaHarness.section.feedbackEyebrow": "Feedback",
  "home.qaHarness.section.feedbackTitle": "Loading, success and action error",
  "home.qaHarness.section.supportEyebrow": "Support",
  "home.qaHarness.section.supportTitle": "Support band, dates and history",
  "home.qaHarness.card.connected": "Connected",
  "home.qaHarness.card.connecting": "Connecting",
  "home.qaHarness.card.error": "Connection error",
  "home.qaHarness.card.readyHero": "Executable hero",
  "home.qaHarness.card.blockedHero": "Waiting hero",
  "home.qaHarness.card.disabledHero": "Disabled hero",
  "home.qaHarness.card.summary": "Summary overview",
  "home.qaHarness.card.allDecisions": "Full list",
  "home.qaHarness.card.blockedDecisions": "Filtered list: waiting",
  "home.qaHarness.card.executableDetail": "Executable detail",
  "home.qaHarness.card.blockedDetail": "Remediation detail",
  "home.qaHarness.card.disabledDetail": "Disabled detail",
  "home.qaHarness.card.lowConfidenceDetail": "Low-confidence detail",
  "home.qaHarness.card.formDetail": "Detail with form",
  "home.qaHarness.card.loadingFeedback": "Action loading",
  "home.qaHarness.card.successFeedback": "Success feedback",
  "home.qaHarness.card.reevaluationFeedback": "Reevaluation queued",
  "home.qaHarness.card.inspectionFeedback": "Inspection-only result",
  "home.qaHarness.card.acknowledgedFeedback": "Business action acknowledged",
  "home.qaHarness.card.manualCompletionFeedback": "Manual completion confirmed",
  "home.qaHarness.card.replayFeedback": "Replay result",
  "home.qaHarness.card.errorFeedback": "Error feedback",
  "home.qaHarness.card.emptyDates": "Empty dates",
  "home.qaHarness.card.emptyActivity": "Empty activity",
  "home.qaHarness.card.emptyMetrics": "Empty metrics",
  "home.qaHarness.controls.openDates": "Open dates panel",
  "home.qaHarness.controls.openHistory": "Open history panel",
  "home.qaHarness.controls.resetPanels": "Reset panels",
};
